import {View, TextInput, TextInputProps} from 'react-native';
import React from 'react';

import {theme} from '../../constants';

type Props = {
  containerStyle?: object;
  value?: string;
  placeholder?: string;
  onChangeText?: TextInputProps['onChangeText'];
};

const InputFieldBig: React.FC<Props> = ({
  containerStyle,
  value,
  placeholder = 'Enter your comment',
  onChangeText,
}): JSX.Element => {
  return (
    <View
      style={{
        width: '100%',
        height: 131,
        backgroundColor: '#E9F3F6',
        borderRadius: 10,
        ...containerStyle,
      }}
    >
      <TextInput
        style={{
          width: '100%',
          height: '100%',
          paddingHorizontal: 24,
          paddingTop: 14,
          paddingBottom: 14,
          color: theme.colors.textPrimary,
          ...theme.fonts.DMSans_400Regular,
          fontSize: 16,
        }}
        placeholder={placeholder}
        textAlignVertical='top'
        multiline={true}
        placeholderTextColor='#A8BCCC'
        value={value}
        onChangeText={onChangeText}
      />
    </View>
  );
};

export default InputFieldBig;
